import React from "react";
import { Outlet } from "react-router-dom";
import { useCrumb } from "@poseidon/ui/app/crumbs/CrumbContext";
import { BoatOptionsProvider } from "./BoatOptionsContext";
import { BaseRoutePathProvider } from "@poseidon/utils/base-route-path";

const BoatsWrapper = ({ baseRoutePath, listDisabled }) => {
  useCrumb(`${baseRoutePath ?? ""}/boats/`, {
    to: listDisabled ? null : `${baseRoutePath ?? ""}/boats`,
    text: "Boats",
  });

  return (
    <BaseRoutePathProvider route={baseRoutePath ?? ""}>
      <BoatOptionsProvider>
        <Outlet />
      </BoatOptionsProvider>
    </BaseRoutePathProvider>
  );
};

export default BoatsWrapper;
